<nav>
    <div class="standard-toolbox-header">
        {{ title }}
        @if (displayCloseButton) {
            <a class="close-button" (click)="onClose()">X</a>
        }
    </div>
    <ng-template #toolboxContainer></ng-template>
</nav>
